/* tslint:disable */
/* eslint-disable */
export enum LoanProductEnum {
  None = 'None',
  AutoLoan = 'AutoLoan',
  PersonalLoan = 'PersonalLoan',
  HomeLoan = 'HomeLoan'
}
